<div *ngIf="isLoading" class="spinner-container">
    <mat-spinner [diameter]="50"></mat-spinner>
</div>
<div class="container">
    <div class="heading-container">
        <mat-icon class="icon" (click)="goBack()">arrow_back</mat-icon>
        <p class="heading">{{ heading }}</p>
    </div>

    <form class="bottom-section" [formGroup]="returnExchangeForm">
        <div class="product-section">
            <div class="product" *ngFor="let item of orderItems; let i = index">
                <img class="product-image" [src]="item.product?.images?.imagesUrl?.[0]" />
                <div class="product-right-section">
                    <p class="product-name">{{ item?.product?.name }}</p>

                    <div class="input-section">
                        <label for="reason">{{ label }}</label>
                        <input
                            id="reason"
                            [formControl]="getReasonControl(i)"
                            class="input-field"
                            placeholder="Mention the reason"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="transation-section" *ngIf="isCod && action === 'return'">
            <div class="input-section">
                <label for="reason">{{ "returnReplaceCancel.selectOtion" | translate }}</label>
                <mat-radio-group formControlName="refundOption" class="radio-group">
                    <mat-radio-button value="bankDetails"
                        ><span class="text">{{
                            "genericDialogBox.label.bankDetails" | translate
                        }}</span></mat-radio-button
                    >
                    <mat-radio-button value="upi"
                        ><span class="">
                            {{ "genericDialogBox.label.upiId" | translate }}
                        </span></mat-radio-button
                    >
                </mat-radio-group>
            </div>

            <div
                *ngIf="returnExchangeForm.get('refundOption')?.value === 'bankDetails'"
                formGroupName="bankDetails"
                class="bank-detail-section"
            >
                <div class="input-section">
                    <input
                        class="input-field"
                        formControlName="accountHolderName"
                        placeholder="Insert account holder name"
                        type="text"
                    />
                </div>
                <div>
                    <p
                        class="text-red"
                        *ngIf="
                            returnExchangeForm.get('bankDetails')?.get('accountHolderName')?.hasError('required') &&
                            returnExchangeForm.get('bankDetails')?.get('accountHolderName')?.touched
                        "
                    >
                        {{ "genericDialogBox.label.accountHolderName" | translate }}
                        {{ "genericDialogBox.invalidMessage.mandatory" | translate }}
                    </p>
                    <mat-error
                        class="text-red"
                        *ngIf="
                            returnExchangeForm
                                .get('bankDetails')
                                ?.get('accountHolderName')
                                ?.hasError('invalidAccountHolderName') &&
                            returnExchangeForm.get('bankDetails')?.get('accountHolderName')?.touched
                        "
                    >
                        {{ "genericDialogBox.invalidMessage.accountNameInvalid" | translate }}
                    </mat-error>
                </div>

                <div class="input-section">
                    <input
                        class="input-field"
                        formControlName="accountNumber"
                        placeholder="Insert bank account number"
                    />
                </div>
                <div>
                    <p
                        class="text-red"
                        *ngIf="
                            returnExchangeForm.get('bankDetails')?.get('accountNumber')?.hasError('required') &&
                            returnExchangeForm.get('bankDetails')?.get('accountNumber')?.touched
                        "
                    >
                        {{ "genericDialogBox.label.accountNo" | translate }}
                        {{ "genericDialogBox.invalidMessage.mandatory" | translate }}
                    </p>
                    <p
                        class="text-red"
                        *ngIf="
                            returnExchangeForm
                                .get('bankDetails')
                                ?.get('accountNumber')
                                ?.hasError('invalidAccountNumber') &&
                            returnExchangeForm.get('bankDetails')?.get('accountNumber')?.touched
                        "
                    >
                        {{ "genericDialogBox.invalidMessage.accountnoInvalid" | translate }}
                    </p>
                </div>

                <div class="input-section">
                    <input class="input-field" formControlName="ifscCode" placeholder="Insert IFSC code" type="text" />
                </div>
                <div>
                    <p
                        class="text-red"
                        *ngIf="
                            returnExchangeForm.get('bankDetails')?.get('ifscCode')?.hasError('required') &&
                            returnExchangeForm.get('bankDetails')?.get('ifscCode')?.touched
                        "
                    >
                        {{ "genericDialogBox.label.ifscCode" | translate }}
                        {{ "genericDialogBox.invalidMessage.mandatory" | translate }}
                    </p>
                    <p
                        class="text-red"
                        *ngIf="
                            returnExchangeForm.get('bankDetails')?.get('ifscCode')?.hasError('invalidIfsc') &&
                            returnExchangeForm.get('bankDetails')?.get('ifscCode')?.touched
                        "
                    >
                        {{ "genericDialogBox.invalidMessage.ifscInvalid" | translate }}
                    </p>
                </div>
            </div>

            <div
                class="bank-detail-section"
                *ngIf="returnExchangeForm.get('refundOption')?.value === 'upi'"
                formGroupName="upi"
            >
                <div class="item-container">
                    <input class="input-field" formControlName="upiId" placeholder="Insert UPI ID" type="email" />
                </div>
                <div>
                    <p class="text-red" *ngIf="returnExchangeForm.get('upi')?.get('upiId')?.hasError('invalidUPI')">
                        {{ "genericDialogBox.invalidMessage.upiIdInvalid" | translate }}
                    </p>
                </div>
            </div>
        </div>

        <div class="button-container" *ngIf="!isLoading">
            <button
                [disabled]="returnExchangeForm.invalid"
                mat-flat-button
                class="save-btn continue-btn"
                (click)="submit()"
            >
                {{ "returnReplaceCancel.button.continue" | translate }}
            </button>
        </div>
    </form>
</div>
